/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneArticlePaywallSuccessfulPayment as ResolvedStandaloneArticlePaywallSuccessfulPayment } from 'base/components/standalone/ArticlePaywall/SuccessfulPayment';

export const ArticlePaywallSuccessfulPayment: typeof ResolvedStandaloneArticlePaywallSuccessfulPayment = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneArticlePaywallSuccessfulPayment {...props} />
        </ErrorBoundary>
    );
});

export type ArticlePaywallSuccessfulPaymentProps = PropsFromComponent<typeof ArticlePaywallSuccessfulPayment>;

/** @deprecated Use slot architecture instead */
export const ArticlePaywallSuccessfulPaymentWith = (extras: DynamicStandaloneExtras): typeof ArticlePaywallSuccessfulPayment => {
    return function ArticlePaywallSuccessfulPayment(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ArticlePaywallSuccessfulPayment');
        return <ResolvedStandaloneArticlePaywallSuccessfulPayment {...mergeProps({ options: { theme } }, props)} />;
    }
}